import { Component, Input, OnInit } from '@angular/core';
import { CompanyLocationDto } from '@bo-client/shared/models/companyLocations';

@Component({
  selector: 'app-company-location-summary',
  templateUrl: './company-location-summary.component.html',
  styleUrls: ['../../../../../../shared/summaries/css-summary.component.scss']
})
export class CompanyLocationSummaryComponent implements OnInit {
  @Input() companyLocation: CompanyLocationDto;

  constructor() {}

  ngOnInit(): void {}
}
